import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import Template from "../../../layout/Template";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { faChevronLeft, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProfissionaisService } from "../../../services/api/Profissionais/ProfissionaisService";
import ProfissionaisMenuLateral from "./ProfissionaisMenuLateral";
import ProfissionalEdit from "./ProfissionalEdit";


const ProfissionaisFicha = () => {

    const { idProfissional } = useParams()
    const [profissional, setProfissional] = useState(null)
    console.log(idProfissional)
    useEffect(() => {

        const fetchData = async () => {
            const res = await ProfissionaisService.getById(idProfissional)
            console.log(res)
            if (res.success) {
                setProfissional(res.data);
            } else {
                setProfissional(null)
            }

        }

        fetchData()
    }, [])

    return (

        <>
            <Template>
            
                {/*}  <Container fluid id="profissional-header">
                    <Row>

                    </Row>
                    <Row>
                        <Col>
                            <h5 className="text-default text-primary"><span className="mr-10">{profissional?.nome} {profissional?.sobrenome} </span>
                                <Button variant="primary" size="sm" href={'/profissionals/cadEdit/' + idProfissional}><FontAwesomeIcon icon={faPenToSquare} /> Editar</Button>
                            </h5>


                        </Col>
                       {/*} <Col>
                            <div>
                                <label className="text-default">Observações:</label> {cliente?.obervacoes}
                            </div>
                            <div>
                                <label className="text-default">Alerta:</label> <span className="text-danger"> {cliente?.alerta}</span>
                            </div>
                        </Col>
                    </Row>

                </Container>*/}

                <ProfissionaisMenuLateral profissional={profissional} contentSel={'edit'}>
                </ProfissionaisMenuLateral>









            </Template>

        </>


    )
}

export default ProfissionaisFicha;